export var styleRoot = 'kvfysmfp';
export var styleChild = 'ufhsfnkm';
export var styles =
  '.' +
  styleRoot +
  '{overflow:hidden;touch-action:none}.' +
  styleChild +
  '{transform-origin: 0 0}';
